<!-- eslint-disable max-len linebreak-style -->
<template>
    <div>
        <b-modal
        id="workorderIncentivePaymentAddModal"
        size="lg"
        @ok="onWorkorderIncentivePaymentAddModalOk()"
        >
        <template v-slot:modal-title>Add Work Order {{ workorderNumber }} Incentive Payment</template>
        <b-card-body
            v-if='totalAvailableExceeded'
            class='project-workorder-incentivepayment-edit-card-warning text-danger'
        >
            <span class='project-workorder-bills-items-details-label'>This incentive payment exceeds the amount available.&nbsp;</span>
        </b-card-body>
        <b-card-body class='project-workorder-incentivepayment-edit-card-body'>
            <b-row>
            <b-col>
                <span class='details-label project-workorder-bills-items-details-label'>Budgeted: </span>
                <span class='project-workorder-bills-items-details-label'>
                {{ totalBudgeted | toCurrency }}
                </span>
            </b-col>
            <b-col>
                <span class='details-label project-workorder-bills-items-details-label'>Obligated: </span>
                <span class='project-workorder-bills-items-details-label'>
                {{ totalObligated | toCurrency }}
            </span>
            </b-col>
            <b-col>
                <span class='details-label project-workorder-bills-items-details-label'>Available: </span>
                <span v-bind:class="{'project-workorder-bills-items-details-label': true, 'text-danger': totalAvailable < 0}">
                {{ totalAvailable | toCurrency }}
                </span>
            </b-col>
            </b-row>
        </b-card-body>
        <VueFormGenerator
            :model="workorderIncentivePaymentAddModel"
            :schema="workorderIncentivePaymentAddSchema"
            :options="{
            validateAfterLoad: false,
            validateAfterChanged: true,
            validateAsync: true
            }"
            @validated="onWorkorderIncentivePaymentAddModelValidated"
        />
        <div>
            <b-card-body>
            </b-card-body>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>Cancel</b-button>
            <b-button size="sm" variant="success" @click="ok" class='btn-success' :disabled='!workorderIncentivePaymentAddModelValid'>Save</b-button>
        </template>
        </b-modal>
    </div>
</template>
<!-- eslint-disable max-len linebreak-style -->
<script>
/* eslint-disable max-len, no-restricted-properties, padded-blocks, prefer-destructuring  */
import { mapState } from 'vuex';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';

export default {
  name: 'ProjectWorkorderIncentivePaymentAdd',
  mixins: [
    ProjectSchemaHelper,
  ],
  computed: {
    ...mapState('Pricelist', {
      pricelistEntries: (e) => e.pricelistEntries,
    }),
    ...mapState('Project', {
      products: (state) => state.products,
      project: (state) => state.project,
      projectBudget: (state) => state.projectBudget,
    }),
    ...mapState('Workorder', {
      workorderIncentivePaymentAddModel: (e) => e.workorderIncentivePaymentAddModel,
      workorderIncentivePaymentAddedModel: (e) => e.workorderIncentivePaymentAddedModel,
    }),
    totalAvailableExceeded() {
      if (!this.workorderIncentivePaymentAddModel) return false;
      if (this.workorderIncentivePaymentAddModel.incentivePaymentId === null) return false;

      const totalAvailable = Math.round(this.totalAvailable * 100);

      const selectedIncentivePayment = this.workorderIncentivePaymentAddModel.incentivePayments
        .find((ip) => ip.id === this.workorderIncentivePaymentAddModel.incentivePaymentId);
      const selectedIncentivePaymentValue = Math.round(selectedIncentivePayment.value.amountPaid * 100);

      const totalAvailableExceeded = totalAvailable < selectedIncentivePaymentValue;
      return totalAvailableExceeded;
    },
  },
  data() {
    return {
      totalBudgeted: 0,
      totalObligated: 0,
      totalAvailable: 0,
      incentivePayments: [],
      workorderIncentivePaymentAddModelValid: false,
      workorderIncentivePaymentAddSchema: null,
    };
  },
  async mounted() {
    this.totalBudgeted = this.workorderIncentivePaymentAddModel.totalBudgeted;
    this.totalObligated = this.workorderIncentivePaymentAddModel.totalObligated;
    this.totalAvailable = (Math.round(this.totalBudgeted * 100) - Math.round(this.totalObligated * 100)) / Math.pow(10, 2);

    this.workorderNumber = this.workorderIncentivePaymentAddModel.workorderNumber;
    this.incentivePayments = this.workorderIncentivePaymentAddModel.incentivePayments;

    this.workorderIncentivePaymentAddSchema = this.getProjectWorkorderIncentivePaymentAddSchema();
    this.$bvModal.show('workorderIncentivePaymentAddModal');
  },
  methods: {
    async onWorkorderIncentivePaymentAddModalOk() {
      await this.$store.dispatch('Workorder/setFormLoading', true);
      const selectedIncentive = this.workorderIncentivePaymentAddModel.incentivePayments.find((ip) => ip.id === this.workorderIncentivePaymentAddModel.incentivePaymentId);
      this.workorderIncentivePaymentAddModel.paymentDate = selectedIncentive.value.datePaid;
      this.workorderIncentivePaymentAddModel.paymentAmount = selectedIncentive.value.amountPaid;
      await this.$store.dispatch('Workorder/postWorkorderIncentivePayment', this.workorderIncentivePaymentAddModel);
      await this.$store.dispatch('Workorder/setFormLoading', false);
    },
    onWorkorderIncentivePaymentAddModelValidated(isValid, errors) {
      this.workorderIncentivePaymentAddModelValid = isValid;
      this.validateWorkOrderIncentivePaymentAddFields(errors);
    },
    validateWorkOrderIncentivePaymentAddFields(errors) {
      this.workorderIncentivePaymentAddModelValid = true;

      if (!this.workorderIncentivePaymentAddModel.incentivePaymentId || this.workorderIncentivePaymentAddModel.incentivePaymentId === null) {
        this.workorderIncentivePaymentAddModelValid = false;
      }

      if (this.totalAvailableExceeded) {
        this.workorderIncentivePaymentAddModelValid = false;
      }

      if (errors && errors.length > 0) {
        this.workorderIncentivePaymentAddModelValid = false;
      }
    },
  },
};
</script>
